import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const LS_KEY = "guinea_locations_v1";
let memo = null;
let inflight = null;

export const norm = (s) =>
  (s || "")
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]/gi, "")
    .toLowerCase();

function readLocal() {
  try {
    return JSON.parse(localStorage.getItem(LS_KEY) || "null");
  } catch {
    return null;
  }
}

export function loadGuinea() {
  if (memo) return Promise.resolve(memo);
  if (!inflight) {
    inflight = api.get("/localisation/guinee").then(({ data }) => {
      memo = data;
      try {
        localStorage.setItem(LS_KEY, JSON.stringify(data));
      } catch {}
      return data;
    });
  }
  return inflight;
}

export function useGuinea() {
  const [data, setData] = useState(() => memo || readLocal());
  useEffect(() => {
    let alive = true;
    loadGuinea()
      .then((d) => alive && setData(d))
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);
  return data;
}

export const allPrefectures = (geo) =>
  (geo?.regions || []).flatMap((r) => r.prefectures.map((p) => ({ ...p, region: r.name, region_id: r.id })));

export const findPrefecture = (geo, name) => allPrefectures(geo).find((p) => norm(p.name) === norm(name)) || null;

export const isConakry = (pref) => !!pref?.communes?.some((c) => c.quartiers);

export function conakryCommuneOf(pref, quartier) {
  const q = norm(quartier);
  if (!pref || !q) return "";
  const c = pref.communes.find((c) => norm(c.name) === q || (c.quartiers || []).some((x) => norm(x) === q));
  return c?.name || "";
}

export function matchesCommune(pref, commune, listingQuartier) {
  const target = norm(commune);
  const q = norm(listingQuartier);
  if (!target) return true;
  if (q === target) return true;
  const c = pref?.communes?.find((x) => norm(x.name) === target);
  return !!c?.quartiers?.some((x) => norm(x) === q);
}
